import React from "react";
import { Modal } from "react-bootstrap";
import moment from "moment";

import afterLoginApiAxios from "../../Util/API Calls/afterLogin";

import Icon from "../../assets/checked.svg";
import "./component-styles.scss";
import swal from "sweetalert";

export default function AppointmentScheduledModal(props) {
    function handleYesClick() {
        props.closeView();
        props.joinVideoCallback();
    }
    return (
        <>
        {props.openView?
        <Modal show={props.openView} onHide={props.closeView} centered={true} dialogClassName="close-ongoing-consult">
            <Modal.Body className="p-3 p-lg-5">
                <div className="d-flex flex-column justify-content-center align-items-center px-3 px-lg-5">
                    <img src={Icon} alt="success" />
                    <h4 className="text-center mt-3">Appointment Scheduled</h4>
                    <p className="text-center my-2">
                        You already have an appointment scheduled at {moment(props.appointment_start_time, "hh:mm:ssZ").format("hh:mm A")}
                        &nbsp;with Patient {props.patient_name}.
                    </p>
                    <p className="text-center my-2 font-weight-bold">
                        Do you still want to continue?
                    </p>
                    <div className="d-flex flex-row justify-content-center my-3">
                        <button className="btn primary-cta-button rounded-pill px-5 mr-2" onClick={handleYesClick}>Yes</button>
                        <button className="btn secondary-button rounded-pill px-5" onClick={props.closeView}>No</button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>:null}
        </>
    )
}